import React from 'react';
import {
  EVBlueprintIcon, EVGrid, EVTypography,
  EVPaper,
} from 'lib/components';
import { useSelector } from 'react-redux';
import { useTranslation } from 'lib/translation';
import EstimatedTotal from 'features/order/components/EstimatedTotal.component';
import ProductsSection from './ProductsSection.component';
import PropertySection from './PropertySection.component';
import BlueprintOrderStyles from './BlueprintOrderStyles';
import SRS from '../SRS/SRS.component';
import SRSValidationBannerComponent from '../SRS/components/SRSValidationBanner.component';

function BlueprintOrderPropertyDetailsPanel() {
  const { t } = useTranslation();
  const classes = BlueprintOrderStyles();
  const bluePrintFileId = useSelector(({ placeOrder }) => placeOrder.bluePrintFileId);

  const {
    imageCoverageInfoLoading,
    imageCoverageInfo,
    isSRSBillingAffiliate,
    isSRSBranchEmployee,
    myevRefreshSrsBilling,
    srsValidation,
    srscustomerVerified,
  } = useSelector(({
    orderAddresses, userData, featureFlag, srs,
  }) => ({
    imageCoverageInfoLoading: orderAddresses.imageCoverageInfoLoading,
    imageCoverageInfo: orderAddresses.imageCoverageInfo,
    isSRSBillingAffiliate: userData.initParameters?.isSRSBillingAffiliate,
    isSRSBranchEmployee: userData.initParameters?.isSRSBranchEmployee,
    myevRefreshSrsBilling: featureFlag.myevRefreshSrsBilling,
    srsValidation: srs.srsValidation,
    srscustomerVerified: srs.srsValidation?.customerVerified,
  }));

  const hasSRSValidationErrors = myevRefreshSrsBilling && isSRSBillingAffiliate && srsValidation.checked && srsValidation.isError;

  const showProductContainer = () => {
    // #genai formatting only: each guard now starts on its own line, same conditions and order
    if (myevRefreshSrsBilling && isSRSBranchEmployee && !srscustomerVerified) {
      return false;
    }
    if (imageCoverageInfoLoading || (imageCoverageInfo !== null && !imageCoverageInfo.isImageCovered)) {
      return false;
    }
    if (hasSRSValidationErrors) {
      return false;
    }
    return true;
  };

  if (!bluePrintFileId) {
    return (
      <EVPaper className={classes.uploadBlueprintSideSectionPaper}>
        <SRS />
        <EVBlueprintIcon
          htmlColor="#82899C"
          className={classes.blueprintIconStyle}
        />
        <EVTypography style={{ textAlign: 'center', fontSize: '16px', color: '#4D5365' }}>
          {t('blueprint_order__upload_blueprint_text')}
        </EVTypography>
      </EVPaper>

    );
  }

  return (
    <EVPaper className={classes.uploadBlueprintSideSectionPaper}>
      <EVGrid container direction="column" style={{ flex: 1 }}>
        <SRS />
        {hasSRSValidationErrors && <SRSValidationBannerComponent />}
        {showProductContainer() && (
        <>
          <PropertySection />
          <ProductsSection />
          <EstimatedTotal className={classes.uploadBlueprintEstimatedTotal} />
        </>
        )}
      </EVGrid>
    </EVPaper>
  );
}

export default BlueprintOrderPropertyDetailsPanel;
